import { useEffect } from "react";
import { Form, Input, Select, Row, Col } from "antd";
import secureLocalStorage from "react-secure-storage";
import { submitSectionThunk } from "../../../store/thunks/sectionsThunk";
import { useDispatch } from "react-redux";
import AddEditForm from "../../../components/molecules/Forms/addEditForm";

const { Option } = Select;

const AddSection = ({ editData, statuses, permissions , onSuccess, children }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const slsLIUId = secureLocalStorage.getItem("lIUId");

  const onSubmit = async (values, editData) => {
    const isEdit = Boolean(editData); 
    const currentStatus = editData?.status || null; 
    const payload = {
      name: values?.name,
      icon: values?.icon,
      permissions: values.permissions,
      historySource: "backend",
      historyAction: isEdit ? "update" : "create",
      historyUserID: slsLIUId,
    };

    if (isEdit) {
      payload.id = editData.key;
    }
    
    if (values.status && values.status !== currentStatus) {
      payload.status = values.status;
    }
    await dispatch(submitSectionThunk(payload)).unwrap();    
  };

  useEffect(() => {
    if (!editData) return;

    form.setFieldsValue({
      name: editData.name,
      icon: editData.icon,
      permissions: editData.permissions,
      status: editData.status,
    });
  }, [editData]);

  return (
      <AddEditForm
        form={form}
        editData={editData}
        onSubmit={onSubmit}
        onSuccess={onSuccess}
        successMessages={{
          create: "Section created successfully",
          update: "Section updated successfully",
        }}
        fields={
          <>
            <Row className="pb-16" gutter={[12, 12]}>
              <Col xs={24} sm={24} md={12} lg={12}>
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    { required: true, message: "Please enter the name!" },
                  ]}
                >
                  <Input placeholder="Enter name" className="w-100" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <Form.Item label="Icon" name="icon">
                  <Input className="w-100" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item
                  className="m-0"
                  label="Permissions"
                  name="permissions"
                  rules={[
                    {
                      required: true,
                      message: "Please enter permission",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    allowClear
                    size="large"
                    className="rounded-md h-45px rounded-md"
                    isclearable="true"
                    mode="multiple"
                    placeholder="Select Permission"
                    options={permissions}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        ?.toLowerCase()
                        .includes(input?.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
              {editData && (
                 <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item
                    label="Status"
                    name="status"
                    rules={[
                      { required: true, message: "Please select a status!" },
                    ]}
                  >
                    <Select
                      showSearch
                      allowClear
                      options={statuses}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input?.toLowerCase())
                      }
                      placeholder="Select Status"
                    />
                  </Form.Item>
                </Col>
              )}
               </Row>                    
          </>
        }
      />        
  );
};
export default AddSection;
